import { useState, useEffect, useCallback } from 'react';
import { safeLocalStorage } from '../utils/safeStorage';

// Notification sound (base64 encoded short beep)
const NOTIFICATION_SOUND = 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleVg7gKq7oG0zFVBzkrbSpnRLLWqdz+eukmE/RXeJl4x3WkJKcYqVj35dREtjdoKBdGRaVV5sdHpybWdjY2duc3h2cnByb3Z6fHt4d3l4e3x9fXx6e3p7fH18fHx7e3t8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8';

export const useNotifications = () => {
  const [soundEnabled, setSoundEnabled] = useState(() => {
    const saved = safeLocalStorage.getItem('notificationSound');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [showPopup, setShowPopup] = useState(false);
  const [memberCount, setMemberCount] = useState(50);
  const [newMembersCount, setNewMembersCount] = useState(0);

  // Save sound preference
  useEffect(() => {
    safeLocalStorage.setItem('notificationSound', JSON.stringify(soundEnabled));
  }, [soundEnabled]);

  const toggleSound = useCallback(() => {
    setSoundEnabled(prev => !prev);
  }, []);

  const playNotificationSound = useCallback(() => {
    if (soundEnabled) {
      try {
        const audio = new Audio(NOTIFICATION_SOUND);
        audio.play().catch(() => {});
      } catch (e) {}
    }
  }, [soundEnabled]);

  const showNotification = useCallback((totalMembers, newMembers = 0) => {
    setMemberCount(totalMembers || 50);
    setNewMembersCount(newMembers || 0);
    setShowPopup(true);
    playNotificationSound();
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 5000);
  }, [playNotificationSound]);

  const hideNotification = useCallback(() => {
    setShowPopup(false);
  }, []);

  return {
    soundEnabled,
    toggleSound,
    showPopup,
    memberCount,
    newMembersCount,
    showNotification,
    hideNotification
  };
};

export default useNotifications;
